import getCommonTestId from 'constants/testsIds/common';
import type { PinnedArticle } from 'interfaces/content/articles/Articles';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import PinnedArticleCard from './PinnedArticleCard';
import * as S from './PinnedArticleStyles';

export interface PinnedCardsListProps {
  articles: PinnedArticle[];
  className?: string;
}

const PinnedCardsList = ({ articles, className }: PinnedCardsListProps) => {
  if (!articles || articles.length === 0) return null;
  return (
    <S.Wrapper
      data-cy={getCommonTestId('PINNED_ARTICLES_LIST')}
      className={className}
      $noOfCards={articles.length}
    >
      {articles.map((article) => (
        <PinnedArticleCard
          article={article}
          key={article.titleLink}
        />
      ))}
    </S.Wrapper>
  );
};

export default withErrorBoundary(PinnedCardsList, { fragment: UIFragments.PINNED_ARTICLES_LIST });
